import React from "react";
import { useDroppable } from "@dnd-kit/core";
import "./index.css";

const Droppable = React.forwardRef((props, ref) => {
  const { isOver, setNodeRef } = useDroppable({
    id: props.id,
    onDrop: () => {
      props.onDrop();
    },
  });

  const hasBackground = !!props.backgroundImage;

  const style = {
    width: "100%",
    aspectRatio: "2 / 1",
    maxHeight: "85vh",
    position: "relative",
    overflow: "hidden",
    ...(hasBackground
      ? {
          backgroundImage: `url(data:image/jpeg;base64,${props.backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }
      : {}),
  };

  return (
    <div
      ref={(node) => {
        setNodeRef(node);
        if (ref) ref.current = node;
      }}
      style={style}
      className="reservations-schema-droppable-area"
    >
      <div className="reservations-schema-grid-overlay" />
      {props.children}
      {isOver && (
        <div className="reservations-schema-droppable-overlay">
          {props.children}
        </div>
      )}
    </div>
  );
});

export { Droppable };
